module.exports = __webpack_public_path__ + "static/media/check.45113e9c.png";